// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 805 ? "25f4ac2a" : chunkId) + "." + {"1":"24f697a31f95b7e8","805":"82ac8ecc1571bb1f","903":"c3c7e1638690a749"}[chunkId] + ".js";
};